export default "__VITE_ASSET__02fa9156__"